// extracted by mini-css-extract-plugin
export var createdDate = "_kc-1";
export var divider = "_kc-2";
export var headerDivider = "_kc-3";
export var messagesCard = "_kc-0";
export var messagesContainer = "_kc-6";
export var messagesContainerWrapper = "_kc-4";
export var showLeftPanelButton = "_kc-8";
export var topButtons = "_kc-7";
export var withPadding = "_kc-5";